import { Badge, BadgeProps, Button, ButtonProps } from "@chakra-ui/react";

interface Props extends ButtonProps {
  href: string;
}

export const CustomButton = (props: Props) => {
  return (
    <Button
      as="a"
      size="sm"
      fontWeight="600"
      fontSize="12px"
      flex={{ base: 1, md: "initial" }}
      target="_blank"
      rel="noreferrer"
      {...props}
    >
      {props.children}
    </Button>
  );
};

export const CustomBadge = (props: BadgeProps) => {
  return (
    <Badge
      fontSize="10px"
      lineHeight="12px"
      bg="backgroundPrimary"
      color="black"
      p="4px 8px"
      borderRadius="12px"
      {...props}
    >
      {props.children}
    </Badge>
  );
};
